import { StandardEvents } from '@shopify/events';

/**
 * <amq-igr-link>: "Mehr Infos zum IGR Zertifikat" above the buy box (blocks/amq_product_igr_link.liquid).
 *
 * Same pattern as assets/amq_product_variant_weight.js: Horizon morphs only the variant picker on a
 * variant change, so this element takes its link and visibility from the matching element in the
 * section HTML the picker fetched. After a switch to another model the picker fetches that model's
 * section, so the PDF is the model's. The switch itself is handled by the model switcher
 * (SWAPPED_ELEMENTS).
 */
class AmqIgrLink extends HTMLElement {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {CustomEvent & { promise?: Promise<{ detail?: { html?: Document } }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;

        const next = html.querySelector(`amq-igr-link[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        this.hidden = next.hasAttribute('hidden');
        this.innerHTML = next.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[amq-igr-link]', error);
      });
  };
}

if (!customElements.get('amq-igr-link')) {
  customElements.define('amq-igr-link', AmqIgrLink);
}
